import { PhoneNumberUtil } from 'google-libphonenumber';

/**
 * Validates phone number based on country code
 * @param phoneNumber
 * @param countryCode
 */
export function isPhoneNumberValid(phoneNumber: string, countryCode: string): boolean {
  if (phoneNumber.length < 4 || phoneNumber.length > 17) return false;
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode.toUpperCase());
    return phoneUtil.isValidNumberForRegion(number, countryCode.toUpperCase());
  } catch {
    return false;
  }
}
